/* eslint-disable no-useless-escape */
import { Button, FormLabel } from "@material-ui/core";
import { Formik } from "formik";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { getContactUs, updateContactUs } from "../../../../../api/contactUsApi";
import { useForceRender } from "../../../../../utils/customHook";
import TextEditor from "../../../../components/TextEditor";
import { useSelector } from "react-redux";
import { swalCondition } from "../../../../../utils/swalHelper";

export default function ContactForm() {
    const [render, forceRender] = useForceRender();

    // ref
    const controllerRef = useRef(null);

    // global redux state
    const { thisMenuPermission } = useSelector(state => {
        const { menuPermission } = state?.menu;
        return {
            thisMenuPermission: menuPermission?.find(menu => menu?.path === window.location.pathname)?.permission,
        };
    });

    // component state
    const [contactDescription, setContactDescription] = useState("");

    const handleOnSubmit = useCallback(
        async values => {
            if (!/[^(<div><br><\/div>)+$]/g.test(values?.textEditor)) {
                swalCondition("ผิดพลาด!!!", "กรุณากรอกข้อมูล", {
                    icon: "error",
                    showCancelButton: false,
                    confirmButtonText: "OK",
                });
                return;
            }
            const isUpdate = await updateContactUs({ content: values?.textEditor }, controllerRef.current?.signal);
            if (isUpdate) {
                swalCondition("สำเร็จ", "บันทึกข้อมูลเรียบร้อย", {
                    icon: "success",
                    showCancelButton: false,
                    confirmButtonText: "OK",
                });
                forceRender();
            }
        },
        [forceRender],
    );

    // run only first render
    useEffect(() => {
        controllerRef.current = new AbortController();
        const init = async () => {
            const contact = await getContactUs(controllerRef.current?.signal);
            if (contact) {
                setContactDescription(contact?.content);
            }
        };
        init();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
    }, [render]);

    return (
        <Formik
            initialValues={{
                textEditor: contactDescription,
            }}
            enableReinitialize
            // validationSchema={object({
            //     textEditor: string()
            //         // .matches(/[^(<p><br><\/p>)+$]/g, "Required.")
            //         .required("Required."),
            // })}
            onSubmit={handleOnSubmit}>
            {({ errors, values, setFieldValue, handleSubmit, setFieldError }) => (
                <div>
                    <FormLabel className="text-dark mb-4" required>
                        Description
                    </FormLabel>
                    <TextEditor
                        value={values?.textEditor}
                        onChange={async val => {
                            await setFieldValue("textEditor", val);
                            if (!/[^(<div><br><\/div>)+$]/g.test(val)) {
                                await setFieldError("textEditor", "Required.");
                            }
                        }}
                        error={errors?.textEditor}
                    />
                    {thisMenuPermission?.create && thisMenuPermission?.edit && (
                        <div className="row justify-content-md-end">
                            <div className="col-12 col-md-3 col-lg-2">
                                <Button onClick={handleSubmit} className="t-btn-primary w-100">
                                    Save
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </Formik>
    );
}
